import { render, staticRenderFns } from "./ProductTransferList.vue?vue&type=template&id=648e1d90&"
import script from "./ProductTransferList.vue?vue&type=script&lang=js&"
export * from "./ProductTransferList.vue?vue&type=script&lang=js&"
import style0 from "./ProductTransferList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports